/**
 * Shared types for entity reference system
 */

export enum RenderMode {
  CARD = 'card',
  LINK = 'link',
  // Future extensibility:
  // COMPACT = 'compact',
  // INLINE = 'inline',
  // PREVIEW = 'preview',
}
